import { archiveUniqueItemHistoryPath, UniqueHistoryConfig, urlCombine } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import { coreAPI, handleResponse, standardGet } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class UniqueHistoryConfigHttpService extends CRUDHelperBase<UniqueHistoryConfig> {
	constructor() {
		super(UniqueHistoryConfig.name);
	}

	async runArchive(options?: HttpResponseOptions) {
		const url = urlCombine(coreAPI, UniqueHistoryConfig.name, archiveUniqueItemHistoryPath);
		const response = await standardGet(url);
		await handleResponse(response, 'Run Delete', 'uniqueHistory', options);
	}
}
